import { useEffect, useState } from "react"
import { BACKEND } from "../../config/configEnvs"
import Modal from "../ui/Modal"
import { FaExternalLinkAlt, FaHeading, FaIdBadge, FaLink, FaLock, FaTrash, FaUser } from "react-icons/fa"
import axios from "axios"
import NoDataScreen from "../ui/temp-screens/NoDataScreen"
import { FaCalendarDays, FaPerson } from "react-icons/fa6"
import { Button } from "@mui/material"
import Tooltip from "../ui/ToolTip"
import { toast } from "react-toastify"
import VerifyValidUrl from "../../utils/VerifyValidUrl"
import CopyToClipBoard from "../../utils/CopyToClipBoard"

const CredentialsBox = ({serviceId}) => {

  const [activeModal, setActiveModal] = useState(false)

  const [serviceData, setServiceData] = useState({})
  const [access, setAccess] = useState([])

  const [newAccessName, setNewAccessName] = useState("")
  const [newAccessLink, setNewAccessLink] = useState("")
  const [newAccessPass, setNewAccessPass] = useState("")
  const [newAccessAcc, setNewAccessAcc] = useState("")

  const getServiceData = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`)
      setServiceData(response.data)
    } catch (e) {
      console.log(e)
    }
  }

  const resetNewAccess = () => {
    setNewAccessName("")
    setNewAccessPass("")
    setNewAccessAcc("")
    setNewAccessLink("")
  }

  const deleteReport = async (id) => {
    try {
      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`)

      if (!response.data || !response.data.listaAccesos) {
        toast.error("Error al obtener los reportes");
        return;
      }

      let arrayAccess = [...response.data.listaAccesos];

      const updatedAccess = arrayAccess.filter(r => r.id !== id);

      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
        listaAccesos: updatedAccess,
      });

      setServiceData(prevData => ({
        ...prevData,
        listaAccesos: prevData.listaAccesos?.filter(r => r.id !== id) || [],
      }));

      getServiceData();
      toast.success("Acceso eliminado con éxito");
    } catch (e) {
      console.log(e);
      toast.error("Error al eliminar el acceso: " + e);
    }
  }

  const createAccess = async () => {
    try {

      if (newAccessName === "" || newAccessPass === "" || newAccessAcc === "" || newAccessLink === "") {
        toast.warning("Rellena los campos correctamente")
        return
      }

      if (!VerifyValidUrl(newAccessLink)) {
        toast.warning("El enlace debe ser una URL válida y comenzar con 'https://'")
        return
      }

      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`)

      if (!response.data) {
        toast.error("Error al actualizar")
        return
      }

      let arrayAccess = response.data.listaAccesos ? [...response.data.listaAccesos] : []

      arrayAccess.push({ 
        link: newAccessLink,
        nombre: newAccessName, 
        cuenta: newAccessAcc,
        pass: newAccessPass,
      })

      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
        listaAccesos: arrayAccess
      })


      getServiceData()
      resetNewAccess()
      toast.success("Acceso guardado con éxito")
      
    } catch (e) {
      console.log(e)
      toast.error("Error al crear el acceso: " + e)
    }
  }

  useEffect(() => {
    getServiceData()
  }, [])

  return (
    <>
      <Modal
        activeModal={activeModal}
        onClose={() => setActiveModal(false)}
        title={"Credenciales"}
        centered
        className="max-w-3xl"
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col border border-gray-200 overflow-y-auto h-[40vh] rounded p-1 gap-2">
            {serviceData.listaAccesos && serviceData.listaAccesos.length > 0 ? (
              serviceData.listaAccesos?.map((a, i) => (
                <div key={i} className="flex flex-col gap-2 border border-gray-100 w-full px-2 py-1 shadow hover:bg">

                  <div className="flex flex-row justify-between items-center w-full gap-2">

                    <div className="bg-gray-100 w-[30%] py-0.5 rounded">
                      <Tooltip content="Perfil cuenta" className="w-full">
                        <div className="flex flex-row text-xs items-center justify-center gap-2">
                          <FaUser className="text-[10px]"/>
                          <span classname="text-xs font-bold w-[30%]">
                            {a.nombre}
                          </span>
                        </div>
                      </Tooltip>
                    </div>

                    <a href={a.link} target="_blank" rel="noopener noreferrer" className="bg-orange-200 w-[30%] py-1 hover:cursor-pointer rounded">
                      <Tooltip content="Ir al acceso" className="w-full">
                        <div className="flex flex-row items-center justify-center">
                          <FaExternalLinkAlt className="text-xs text-orange-500" />
                        </div>
                      </Tooltip>
                    </a>

                    <button onClick={() => CopyToClipBoard(a.cuenta)} className="bg-blue-200 w-[30%] py-1 rounded">
                      <Tooltip content="Copiar nombre de usuario" className="w-full">
                        <div className="flex flex-row items-center justify-center">
                          <FaUser className="text-xs text-blue-500" />
                        </div>
                      </Tooltip>
                    </button>

                    <button onClick={() => CopyToClipBoard(a.pass)} className="bg-green-200 w-[30%] py-1 rounded">
                      <Tooltip content="Copiar contraseña">
                        <div className="flex flex-row items-center justify-center">
                          <FaLock className="text-xs text-green-500" />
                        </div>
                      </Tooltip>
                    </button>

                    <button onClick={() => deleteReport(a.id)} className="bg-red-200 w-[10%] py-1 rounded">
                      <Tooltip content="Eliminar acceso">
                        <div className="flex flex-row items-center justify-center">
                          <FaTrash className="text-xs text-red-500" />
                        </div>
                      </Tooltip>
                    </button>

                  </div>

                </div>
              ))
            ) : (
              <NoDataScreen />
            )}
          </div>
          <div className="flex flex-col items-start justify-start gap-3">
            <span className="text-xs">Registra un nuevo acceso</span>
            <div className="flex flex-col gap-2 w-full items-center justify-center">

              <div className="flex flex-row gap-2 w-full items-center justify-center">

                <div className="flex w-1/2">
                  <span className="text-xs inline-flex font-bold items-center gap-2 px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 rounded-s-md border-gray-300 border-e-0  ">
                    <FaLock />
                  </span>
                  <input
                    type="text"
                    placeholder="Link de acceso (.com)"
                    value={newAccessLink}
                    onChange={(e) => setNewAccessLink(e.target.value)}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block rounded-s-0 rounded-e-md flex-1 min-w-0 w-full text-sm border-gray-300 p-2" 
                  />
                </div>

                <div className="flex w-1/2">
                  <span className="text-xs inline-flex font-bold items-center gap-2 px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 rounded-s-md border-gray-300 border-e-0">
                    <FaUser />
                  </span>
                  <input
                    type="text"
                    placeholder="Perfil de la cuenta (Administrador, cliente, moderador, etc)"
                    value={newAccessName}
                    onChange={(e) => setNewAccessName(e.target.value)}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block rounded-s-0 rounded-e-md flex-1 min-w-0 w-full text-sm border-gray-300 p-2" 
                  />
                </div>


              </div>

              <div className="flex flex-row gap-2 w-full items-center justify-center">

                <div className="flex w-1/2">
                  <span className="text-xs inline-flex font-bold items-center gap-2 px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 rounded-s-md border-gray-300 border-e-0  ">
                    <FaIdBadge  />
                  </span>
                  <input
                    type="text"
                    placeholder="Cuenta (email, nombre de usuario)"
                    value={newAccessAcc}
                    onChange={(e) => setNewAccessAcc(e.target.value)}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block rounded-s-0 rounded-e-md flex-1 min-w-0 w-full text-sm border-gray-300 p-2" 
                  />
                </div>

                <div className="flex w-1/2">
                  <span className="text-xs inline-flex font-bold items-center gap-2 px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 rounded-s-md border-gray-300 border-e-0  ">
                    <FaLock />
                  </span>
                  <input
                    type="text"
                    placeholder="Contraseña"
                    value={newAccessPass}
                    onChange={(e) => setNewAccessPass(e.target.value)}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block rounded-s-0 rounded-e-md flex-1 min-w-0 w-full text-sm border-gray-300 p-2" 
                  />
                </div>

              </div>

              <Button 
                variant="contained"
                onClick={() => createAccess()}
                sx={{
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  paddingBlock: "4px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "100%",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
              >
                Crear Acceso
              </Button>

            </div>
          </div>
        </div>
      </Modal>
      <button 
        className="flex flex-row gap-2 items-center justify-center text-xs bg-gray-100 rounded py-2 font-semibold hover:shadow-md hover:bg-gray-200 transition-all duration-100"
        onClick={() => setActiveModal(true)}
      >
        <span>Ver accesos</span>
        <FaLock />
      </button>
    </>
  )
}

export default CredentialsBox